import { createSlice } from "@reduxjs/toolkit";

// photoid: number;

// plate = 0
// image=1
// fullImage=2

const initialState = { imageType: null };

export const imageTypeSlice = createSlice({
  name: "imageType",
  initialState,
  reducers: {
    setImageType: (state, action) => {
      state.imageType = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setImageType } = imageTypeSlice.actions;

export default imageTypeSlice.reducer;
